import React from 'react';

function CenteredLogo(props) {
  return (
    <img
      src={props.logo}
      alt="CenteredLogo"
      style={{
        opacity: `${props.opacity || 0.4}`,
        position: 'absolute',
        top: '50%',
        left: '50%',
        width: `${props.size || 300}px`,
        height: `${props.size || 300}px`,
        marginTop: `${-props.size / 2 || -150}px` /* Half the height */,
        marginLeft: `${-props.size / 2 || -150}px` /* Half the width */,
      }}
    />
  );
}

export default CenteredLogo;
